module.exports = __webpack_public_path__ + "static/media/slide1.92056013.png";